<template>
  <div class="container">
    <table class="table is-fullwidth">
      <thead>
      <tr>
        <th>email</th>
        <th>created at</th>
        <th>status</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(user, key) in sortedUsers" v-bind:key="key">
        <td @click="getPreferences(key)"> {{ user.email }}</td>
        <td>{{ formatDate(user.created_at) }}</td>
        <td>
          <button @click="deactivate(key, user.id)" class="is-primary is-small button">
            Delete
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <Preferences :preferences="preferences" v-on:close="preferences = null" v-if="preferences"></Preferences>
</template>

<script>
import Preferences from "./Preferences";
import {deactivateUser, getPreferencesByUserID, getUsers} from "../../api/api"

export default {
  data() {
    return {users: [], preferences: null}
  },
  components: {
    Preferences,
  },
  computed: {
    sortedUsers() {
      return [...this.users].sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
    async getPreferences(key) {
      let prefs = await getPreferencesByUserID(this.sortedUsers[key].id).then(resp => resp.data)
      if (prefs == null) {
        prefs = []
      }
      this.preferences = prefs
    },
    async deactivate(key, userId) {
      try {
        await deactivateUser(userId)
        this.users = await this.getUsers()
      } catch (e) {
        console.error(e)
      }

    },
    async getUsers() {
      try {
        return await getUsers().then(resp => resp.data)
      } catch (e) {
        console.error(e)

        return []
      }
    }
  },
  async created() {
    this.users = await this.getUsers()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
